export const relativeQuestions = [
  {
    id: 1,
    koreanQuestion:
      "후보자, 그....인사 담당자가 추천한 받았다 여러 개의 일자리 제안을",
    question:
      "The candidate ______ the hiring manager endorsed received multiple job offers.",
    choices: {
      A: "who",
      B: "whom",
      C: "whose",
      D: "which",
    },
    correctAnswer: "B",
    explanation:
      "그...앞이 후보자(사람)이고 그.. 뒤에는 인사 담당자가 추천했다 ___ 으로 목적어 자리가 비어있습니다. 정답은 목적격인 whom입니다. ",
    translation:
      "인사 담당자가 추천한 후보자는 여러 개의 일자리 제안을 받았다.",
    type: "relative pronoun",
  },
];
